import { useCallback, useEffect, useState } from "react"

export function useIsVisible() {
    const [isVisible, setIsVisible] = useState(false)
    const [element, setElement] = useState<HTMLElement | null>(null)

    const containerRef = useCallback((el: HTMLElement | null) => setElement(el), [])

    useEffect(() => {
        if (!element) return
        const observer = new IntersectionObserver((entries) => {
            setIsVisible(entries[0].isIntersecting)
        })
        observer.observe(element)
        return () => observer.disconnect()
    }, [element])

    return { isVisible, containerRef }
}
